import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useNextRouterContext } from "@faire/retailer-visitor-shared/app/_lib/routing/NextRouterContext";
import { topNavEvent } from "@faire/retailer-visitor-shared/components/Header/Events";
import { HeaderStoreProvider } from "@faire/retailer-visitor-shared/components/Header/HeaderStoreProvider";
import { LazyMobileMenu } from "@faire/retailer-visitor-shared/components/Header/mobile/MobileMenu/index";
import { HeaderLinkButton } from "@faire/retailer-visitor-shared/components/Header/styled";
import { useHeaderState } from "@faire/retailer-visitor-shared/components/Header/useHeaderState";
import { useRetailer } from "@faire/retailer-visitor-shared/hooks/retailer/useRetailer";
import { useIsLoggedInRetailer } from "@faire/retailer-visitor-shared/lib/isLoggedInRetailer";
import { useSettingNextJSRscCategoryPage } from "@faire/retailer-visitor-shared/settings/useSettingNextJSRscCategoryPage";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { useIsSSR } from "@faire/web--source/common/server-side-rendering/isSSR";
import { Hamburger } from "@faire/web--source/ui/Hamburger";
import { useViewportWidth } from "@faire/web--source/ui/hooks/useViewportWidth";
import { route as categoryC1Route } from "@faire/web-api--source/routes/www/category/c1CategoryUrlId";
import { observer } from "mobx-react";
import React, { Suspense } from "react";
var HeaderMobileHamburgerMenuBase = function() {
    var width = useViewportWidth(function(width) {
        return width;
    });
    var strictLocalize = useStrictLocalization().strictLocalize;
    var isSSR = useIsSSR();
    var isLoggedInRetailer = useIsLoggedInRetailer();
    var _useNextRouterContext = useNextRouterContext(), nextPrefetch = _useNextRouterContext.prefetch;
    var _useHeaderState = useHeaderState(), isShowingMenu = _useHeaderState.isShowingMenu, hideMenu = _useHeaderState.hideMenu, showMenu = _useHeaderState.showMenu;
    var isRSCCategoryPageEnabled = useSettingNextJSRscCategoryPage();
    var retailerToken = useRetailer().retailerToken;
    var toggleMenu = function() {
        var trackToggleEvent = isShowingMenu ? topNavEvent("close", retailerToken !== null && retailerToken !== void 0 ? retailerToken : "") : topNavEvent("open", retailerToken !== null && retailerToken !== void 0 ? retailerToken : "");
        if (!isShowingMenu && isLoggedInRetailer && !isRSCCategoryPageEnabled) {
            nextPrefetch(categoryC1Route);
        }
        isShowingMenu ? hideMenu() : showMenu();
        trackToggleEvent();
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(HeaderLinkButton, {
                onClick: toggleMenu,
                "data-test-id": "mobile-menu-button",
                disabled: isSSR,
                $width: width,
                "aria-label": strictLocalize({
                    id: "RM6Zhi",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Menu button"
                        }
                    ]
                }),
                children: /*#__PURE__*/ _jsx(Hamburger, {})
            }),
            isShowingMenu ? /*#__PURE__*/ _jsx(Suspense, {
                fallback: null,
                children: /*#__PURE__*/ _jsx(LazyMobileMenu, {
                    onClose: toggleMenu
                })
            }) : null
        ]
    });
};
var HeaderMobileHamburgerMenuWrapper = function() {
    return /*#__PURE__*/ _jsx(HeaderStoreProvider, {
        children: /*#__PURE__*/ _jsx(HeaderMobileHamburgerMenuBase, {})
    });
};
export var HeaderMobileHamburgerMenu = observer(HeaderMobileHamburgerMenuWrapper);
